<script>
	import {M} from "../../external";

	let isVisible = true;
	let isActive = false;
	let isVisible2 = true;
	let isActive2 = false;
	let isVisible3 = true;
	let isActive3 = false;
	let isVisible4 = false;
	let isActive4 = true;

    function toggleDiv() {
        isVisible = !isVisible;
        isActive = !isActive;
    }

    function toggleDiv2() {
        isVisible2 = !isVisible2;
        isActive2 = !isActive2;
    }

    function toggleDiv3() {
        isVisible3 = !isVisible3;
        isActive3 = !isActive3;
    }

    function toggleDiv4() {
        isVisible4 = !isVisible4;
        isActive4 = !isActive4;
    }
</script>


<div class="admin-circle-wrapper col20 f-left flex justify-center flex-col align-center mb-35">


	<div class="account-settings none" style="height: auto;">
		<div class="top-background-wrapper narrow-top-background dash-top-background" style="padding-top: 15px;"><div class="top-background"></div></div>
		<div class="content-wrapper">
			<div class="sections-wrapper profile-inner-wrapper bg-white box-shadow" style="margin-bottom: 60px;overflow:hidden;">
				<div class="col20 f-left getting-started-layout getting-started-layout-big v2">
					<div class="col20 f-left flex align-center flex-col-mobile mb-55">
						<div class="col11 f-left flex justify-center flex-col">
							<h4 class="col20 f-left"><span>{M.GETTING_STARTED}</span></h4>
							<h1 class="col20 f-left mt-10 mb-15">Start Your Community Circles</h1>
							<span class="col20 f-left paragraph-text mb-10">With the Circles functionality you can start your membership areas, build your courses, meanage members, organize content, and have paywalls to access that content.</span>
							<div class="col20 f-left mt-15">
								<a href="" class="big-button with-icon blue">Create A Circle</a>
							</div>
						</div>
						<div class="col9 f-left justify-center align-center flex flex-col store-getting-started">
							<div class="col20 f-left gray-section product-select-wrapper">
								<div class="col20 f-left ab-step center-vertically">
									<div class="small-circle-icon"><span class="material-icons-outlined"> hdr_weak </span></div>
									<div>
										<h4 class="roboto">Create A Circle</h4>
										<span class="light-gray-text mt-5 ml-0">{M.SMALL_PERIOD_EXAMPLE}</span>
									</div>
									<a class="text-link blue-text" rel="tab" href="/me/store/products/">{M.CREATE}</a>
								</div>
							</div>
							<div class="col20 f-left gray-section product-select-wrapper">
								<div class="col20 f-left ab-step center-vertically">
									<div class="small-circle-icon"><span class="material-icons-outlined"> credit_card </span></div>
									<div>
										<h4 class="roboto">{M.CONNECT_PROCESSOR}</h4>
										<span class="light-gray-text mt-5 ml-0">{M.SMALL_PERIOD_EXAMPLE}</span>
									</div>
									<a class="text-link blue-text" rel="tab" href="/me/store/settings#payments">{M.CONNECT}</a>
								</div>
							</div>
							<div class="col20 f-left gray-section product-select-wrapper">
								<div class="col20 f-left ab-step center-vertically">
									<div class="small-circle-icon"><span class="material-icons-outlined"> account_circle  </span></div>
									<div>
										<h4 class="roboto">Add Members</h4>
										<span class="light-gray-text mt-5 ml-0">{M.SMALL_PERIOD_EXAMPLE}</span>
									</div>
									<a class="text-link blue-text" rel="tab" href="/me/store/settings">{M.ADD}</a>
								</div>
							</div>
						</div>
					</div>

					<div class="col20 f-left flex align-center flex-col-mobile mb-55">
						<div class="col18 f-left flex justify-center flex-col">
							<h4 class="col20 f-left"><span>{M.GETTING_STARTED}</span></h4>
							<h1 class="col20 f-left mt-10 mb-15">Welcome to your Community Center!</h1>
							<span class="col14 f-left paragraph-text mb-10">With the Circles functionality you can start your membership areas, build your courses, meanage members, organize content, and have paywalls to access that content.</span>
						</div>
					</div>

					<div class="col20 f-left">
						<div class="col11 f-left">
							<div class="flex col20 space-between mb-15 align-center">
								<h2 class="f-left f-28 gray-text">Latest Circles</h2>
								<a href="" class="middle-button with-icon blue flex-none">Create A Circle</a>
							</div>
							<div class="list-circle-wrapper col20 f-left flex align-center space-between">
								<div class="flex align-center">
									<div class="list-circle-profile">
										<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M200-320q-66 0-113-47T40-480q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm480 80q-100 0-170-70t-70-170q0-100 70-170t170-70q100 0 170 70t70 170q0 100-70 170t-170 70Zm0-80q66 0 113-47t47-113q0-66-47-113t-113-47q-66 0-113 47t-47 113q0 66 47 113t113 47Z"/></svg>
									</div>
									<div class="list-circle-header">
										<h4 class="list-circle-name col20 f-left">Circle Name</h4>
										<span class="list-circle-members f-left"><b>722</b> Members</span>
									</div>
								</div>
								<div class="list-circle-controls flex-none">
									<span class="order-status completed mr-10 f-left">Published</span>
									<a href="" class="f-left mr-5"><span class="material-icons-outlined">analytics</span></a>
									<a href="" class="f-left"><span class="material-icons-outlined">settings</span></a>
								</div>
							</div>

							<div class="list-circle-wrapper col20 f-left flex align-center space-between">
								<div class="flex align-center">
									<div class="list-circle-profile">
										<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M480-120 200-272v-240L40-600l440-240 440 240v320h-80v-276l-80 44v240L480-120Zm0-332 274-148-274-148-274 148 274 148Zm0 241 200-108v-151L480-360 280-470v151l200 108Zm0-241Zm0 90Zm0 0Z"/></svg>
									</div>
									<div class="list-circle-header">
										<h4 class="list-circle-name col20 f-left">Circle Name</h4>
										<span class="list-circle-members f-left"><b>722</b> Members</span>
									</div>
								</div>
								<div class="list-circle-controls flex-none">
									<span class="order-status completed mr-10 f-left">Published</span>
									<a href="" class="f-left mr-5"><span class="material-icons-outlined">analytics</span></a>
									<a href="" class="f-left"><span class="material-icons-outlined">settings</span></a>
								</div>
							</div>
							<div class="list-circle-wrapper col20 f-left flex align-center space-between">
								<div class="flex align-center">
									<div class="list-circle-profile">
										<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M480-120 200-272v-240L40-600l440-240 440 240v320h-80v-276l-80 44v240L480-120Zm0-332 274-148-274-148-274 148 274 148Zm0 241 200-108v-151L480-360 280-470v151l200 108Zm0-241Zm0 90Zm0 0Z"/></svg>
									</div>
									<div class="list-circle-header">
										<h4 class="list-circle-name col20 f-left">Circle Name</h4>
										<span class="list-circle-members f-left"><b>722</b> Members</span>
									</div>
								</div>
								<div class="list-circle-controls flex-none">
									<span class="order-status completed mr-10 f-left">Published</span>
									<a href="" class="f-left mr-5"><span class="material-icons-outlined">analytics</span></a>
									<a href="" class="f-left"><span class="material-icons-outlined">settings</span></a>
								</div>
							</div>
							<div class="col20 f-left mt-5 t-center"><a class="blue-text inline-block">View All Circles</a></div>
						</div>
						<div class="col8 f-right">
							<div class="col20 analytics-box-big">
								<div class="col20 analytics-box analytics-box-small">
									<h3>New Members</h3>
									<h2 class="col20 f-left f-28 gray-text"><b>722</b></h2>
								</div>
								<div class="col20 analytics-box analytics-box-small">
									<h3>Revenue</h3>
									<h2 class="col20 f-left f-28 gray-text"><b>$7,523.32</b><span>(62 Orders)</span></h2>
								</div>
								<div class="col20 analytics-box analytics-box-small">
									<h3>New Subscriptions</h3>
									<h2 class="col20 f-left f-28 gray-text"><b>75</b></h2>
								</div>
								<div class="col20 analytics-box analytics-box-small">
									<h3>Cancelations (Churn)</h3>
									<h2 class="col20 f-left f-28 gray-text"><b>12</b></h2>
								</div>
								<div class="col20 f-left mt-10 t-center gray-text" style="opacity:.6;"><i>(Stats in the last 30 days)</i></div>
							</div>
							<div class="col20 f-left mt-10 t-center"><a class="blue-text inline-block">View All Analytics</a></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>


<!--
	<div class="top-background-wrapper narrow-top-background dash-top-background" style="padding-top: 25px;">
		<div class="top-background">
			<div class="text-wrapper flex align-center space-between">
				<div class="flex align-center flex-none">
					<a rel="tab" href="/me/store/products" class="back-to-next-step flex-none" style="width: auto; margin-bottom: 0px; margin-right: 20px;">← Back To All Circles</a>
				</div>
				<div class="store-product-buttons flex align-center">
					<a rel="action" data-action="showMoreOptions" class="crm-option f-right" style="margin-right: 5px; padding-right: 33px;">More <svg class="interface-icon o__standard" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 16 16"><path d="M4 6l4 4 4-4H4z"></path></svg></a>
					<a class="f-right middle-button blue mr-5" style="height: 39px; line-height: 39px;">Preview</a>
					<a class="f-right middle-button blue mr-5" style="height: 39px; line-height: 39px;">Circle Analytics</a>
					<div class="flex align-center f-right mr-5 subscriber-action-wrapper">
					  <span class="f-left unsubscribe-text" data-role="subs-status-text">Not Published</span>
					  <a data-action="changeSubscriptionStatus" class="middle-button rounded-effect ml-15 f-right flex-none green" data-role="subs-status-button" rel="action">Publish</a>
					</div>
				</div>
			</div>
		</div>
	</div>
-->

	
	<!-- User Side Profile -->

	<div class={`side-profile-wrapper ${isActive2 ? 'show' : ''}`}>
		<div class="col20 f-left side-profile-image-outer flex justify-center mt-15">
			<div class="side-profile-image" style="background-image: url(&quot;https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg&quot;);"></div>
		</div>
		<div class="col20 f-left flex justify-center mt-15 mb-25 flex-col side-profile-header">
			<h2 class="side-profile-name col20 f-left">Stanislav Petrov</h2>
			<div class="col20 f-left t-center mt-15 mb-25">
				<a href="" class="side-profile-link-btn rounded-effect"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"/></svg></a>
				<a href="" class="side-profile-link-btn rounded-effect"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg></a>
				<a href="" class="side-profile-link-btn rounded-effect"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/></svg></a>
				<a href="" class="side-profile-link-btn rounded-effect"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 8C119.3 8 8 119.3 8 256s111.3 248 248 248 248-111.3 248-248S392.7 8 256 8zm164 114.4c29.5 36 47.4 82 47.8 132-7-1.5-77-15.7-147.5-6.8-5.8-14-11.2-26.4-18.6-41.6 78.3-32 113.8-77.5 118.3-83.5zM396.4 97.9c-3.8 5.4-35.7 48.3-111 76.5-34.7-63.8-73.2-116.2-79-124 67.2-16.2 138 1.3 190.1 47.5zm-230.5-33.3c5.6 7.7 43.4 60.1 78.5 122.5-99.1 26.3-186.4 25.9-195.8 25.8C62.4 147.2 106.7 92.6 165.9 64.6zM44.2 256.3c0-2.2 0-4.3 .1-6.5 9.3 .2 111.9 1.5 217.7-30.1 6.1 11.9 11.9 23.9 17.2 35.9-76.6 21.6-146.2 83.5-180.5 142.3C64.8 360.4 44.2 310.7 44.2 256.3zm81.8 167.1c22.1-45.2 82.2-103.6 167.6-132.8 29.7 77.3 42 142.1 45.2 160.6-68.1 29-150 21.1-212.8-27.9zm248.4 8.5c-2.2-12.9-13.4-74.9-41.2-151 66.4-10.6 124.7 6.8 131.9 9.1-9.4 58.9-43.3 109.8-90.8 142z"/></svg></a>
			</div>
			<span class="side-profile-description col20 f-left">An optional description about the user will go in this area.</span>
		</div>
	</div>

	<!-- Circle TOP Controls -->

	<div class="advanced-buttons-wrapper">
	  <div class="inner-wrapper">
	    <a href="/me/community/circles" rel="tab" class="advanced-circle-button circle-effect f-left">
	      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21v-2z"/></svg>
	    </a>
	    <div style="display: inline-block;">
	    	<a rel="action" data-action="showBlogSettings" class="advanced-circle-button circle-effect f-left">
	    	  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg>
	    	</a>
	    	<a rel="action" data-action="showBlogSettings" class="advanced-circle-button circle-effect f-left">
	    	  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M7 16c.55 0 1 .45 1 1 0 1.1-.9 2-2 2-.17 0-.33-.02-.5-.05.31-.55.5-1.21.5-1.95 0-.55.45-1 1-1M18.67 3c-.26 0-.51.1-.71.29L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41l-1.34-1.34c-.2-.2-.45-.29-.7-.29zM7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3z"></path></svg>
	    	</a>
	    	<a rel="action" data-action="showBlogSettings" class="advanced-circle-button circle-effect f-left">
	    	  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M280-280h80v-200h-80v200Zm320 0h80v-400h-80v400Zm-160 0h80v-120h-80v120Zm0-200h80v-80h-80v80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"></path></svg>
	    	</a>
	    	<a rel="action" data-action="showBlogStylings" class="advanced-circle-button circle-effect f-left">
	    	  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M880-80 720-240H320q-33 0-56.5-23.5T240-320v-40h440q33 0 56.5-23.5T760-440v-280h40q33 0 56.5 23.5T880-640v560ZM160-473l47-47h393v-280H160v327ZM80-280v-520q0-33 23.5-56.5T160-880h440q33 0 56.5 23.5T680-800v280q0 33-23.5 56.5T600-440H240L80-280Zm80-240v-280 280Z"></path></svg>
	    	</a>
	    	<a rel="action" data-action="showBlogComments" class="advanced-circle-button circle-effect f-left">
	    	  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="m354-287 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-120l65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-350Z"></path></svg>
	    	</a>
	    	<a rel="action" data-action="showBlogComments" class="advanced-circle-button circle-effect f-left">
	    		<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M240-400q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm240 0q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm240 0q-33 0-56.5-23.5T640-480q0-33 23.5-56.5T720-560q33 0 56.5 23.5T800-480q0 33-23.5 56.5T720-400Z"></path></svg>
	    	</a>
	    </div>
	    <div class="flex align-center f-right mr-5 subscriber-action-wrapper" style="margin-top: 0;">
	      <span class="f-left unsubscribe-text" data-role="subs-status-text">Not Published</span>
	      <a data-action="changeSubscriptionStatus" class="middle-button rounded-effect ml-15 f-right flex-none green" data-role="subs-status-button" rel="action">Publish</a>
	    </div>
	  </div>
	</div>

	<div class="advanced-buttons-wrapper none">
	  <div class="inner-wrapper">
	    <a rel="action" data-action="showBlogList" class="advanced-circle-button circle-effect f-left">
	      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21v-2z"/></svg>
	    </a>
	    <a rel="action" data-action="showBlogSettings" class="advanced-circle-button circle-effect f-left">
	      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg>
	    </a>
	    <a rel="action" data-action="showBlogSettings" class="advanced-circle-button circle-effect f-left">
	      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M280-280h80v-200h-80v200Zm320 0h80v-400h-80v400Zm-160 0h80v-120h-80v120Zm0-200h80v-80h-80v80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"></path></svg>
	    </a>
	    <div style="display: inline-block; margin-top:6px;">
	      <div class="flex align-center f-right mr-5 subscriber-action-wrapper">
	        <span class="f-left unsubscribe-text" data-role="subs-status-text">Not Published</span>
	        <a data-action="changeSubscriptionStatus" class="middle-button rounded-effect ml-15 f-right flex-none green" data-role="subs-status-button" rel="action">Publish</a>
	      </div>
	    </div>
	    <a rel="action" data-action="showBlogComments" class="advanced-circle-button circle-effect f-right">
	    	<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M240-400q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm240 0q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm240 0q-33 0-56.5-23.5T640-480q0-33 23.5-56.5T720-560q33 0 56.5 23.5T800-480q0 33-23.5 56.5T720-400Z"></path></svg>
	    </a>
	    <a rel="action" data-action="showBlogStylings" class="advanced-circle-button circle-effect f-right">
	      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M880-80 720-240H320q-33 0-56.5-23.5T240-320v-40h440q33 0 56.5-23.5T760-440v-280h40q33 0 56.5 23.5T880-640v560ZM160-473l47-47h393v-280H160v327ZM80-280v-520q0-33 23.5-56.5T160-880h440q33 0 56.5 23.5T680-800v280q0 33-23.5 56.5T600-440H240L80-280Zm80-240v-280 280Z"></path></svg>
	    </a>
	    <a rel="action" data-action="showBlogComments" class="advanced-circle-button circle-effect f-right">
	      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="m354-287 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-120l65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-350Z"></path></svg>
	    </a>
	  </div>
	</div>

	<!-- Circle TOP Controls END -->

	<!-- Side Circle Controls

	<div class="circle-content-controls">
		<div class="circle-side-controls">
			<a href=""><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg></a>
			<a href=""><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg></a>
			<a href=""><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M280-280h80v-200h-80v200Zm320 0h80v-400h-80v400Zm-160 0h80v-120h-80v120Zm0-200h80v-80h-80v80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"/></svg></a>
			<a href=""><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M880-80 720-240H320q-33 0-56.5-23.5T240-320v-40h440q33 0 56.5-23.5T760-440v-280h40q33 0 56.5 23.5T880-640v560ZM160-473l47-47h393v-280H160v327ZM80-280v-520q0-33 23.5-56.5T160-880h440q33 0 56.5 23.5T680-800v280q0 33-23.5 56.5T600-440H240L80-280Zm80-240v-280 280Z"/></svg></a>
			<a href=""><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="m354-287 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-120l65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-350Z"/></svg></a>
			<a href=""><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M240-400q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm240 0q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm240 0q-33 0-56.5-23.5T640-480q0-33 23.5-56.5T720-560q33 0 56.5 23.5T800-480q0 33-23.5 56.5T720-400Z"/></svg></a>
		</div>
	</div>-->

	<!-- CIRCLE LAYOUT 2 -->
	<div class="circle-wrapper mt-55 flex flex-1 flex-row" class:circle-layout-1={isActive3 || !isVisible} class:circle-layout-2={!isActive3 && isVisible} style="max-height: 80vh;">
		<!--
		<div class="circle-head-navigation">
			<div class="circle-head-left flex align-center">
				<div class="circle-cover col20 f-left">
					<a href="" class="circle-profile-btn rounded-effect">
						<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24"></rect></g><g><g><path d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M7.35,18.5C8.66,17.56,10.26,17,12,17 s3.34,0.56,4.65,1.5C15.34,19.44,13.74,20,12,20S8.66,19.44,7.35,18.5z M18.14,17.12L18.14,17.12C16.45,15.8,14.32,15,12,15 s-4.45,0.8-6.14,2.12l0,0C4.7,15.73,4,13.95,4,12c0-4.42,3.58-8,8-8s8,3.58,8,8C20,13.95,19.3,15.73,18.14,17.12z"></path><path d="M12,6c-1.93,0-3.5,1.57-3.5,3.5S10.07,13,12,13s3.5-1.57,3.5-3.5S13.93,6,12,6z M12,11c-0.83,0-1.5-0.67-1.5-1.5 S11.17,8,12,8s1.5,0.67,1.5,1.5S12.83,11,12,11z"></path></g></g></svg>
					</a>
				</div>
				<div class="col20 f-left circle-image-outer small flex justify-center">
					<div style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)"  class="circle-image"></div>
				</div>
			</div>
		</div>
	-->
		<div class="circle-group-sidebar-overlay" class:none-soft={isActive4 || !isVisible}></div>
		<div class="circle-navigation relative flex flex-row">
			<span class={`expand-collapse-navigation-btn rounded-effect ${isActive ? 'rotate' : ''}`} on:click={toggleDiv}>
				<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m600-200-57-56 184-184H80v-80h647L544-704l56-56 280 280-280 280Z"/></svg>
			</span>
			<div class="circle-mobile-nav none-soft circle-effect" on:click={toggleDiv3}>
				<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z"/></svg>
			</div>
			<div class="circle-mobile-sub-nav none-soft circle-effect" on:click={toggleDiv4}>
				<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M666-440 440-666l226-226 226 226-226 226Zm-546-80v-320h320v320H120Zm400 400v-320h320v320H520Zm-400 0v-320h320v320H120Zm80-480h160v-160H200v160Zm467 48 113-113-113-113-113 113 113 113Zm-67 352h160v-160H600v160Zm-400 0h160v-160H200v160Zm160-400Zm194-65ZM360-360Zm240 0Z"/></svg>
			</div>
			<div class={`circle-sidebar custom-scroll ${isActive3 ? 'show-menu' : ''}`}>
				<div class="circle-cover col20 f-left">
					<a class="circle-profile-btn rounded-effect" on:click={toggleDiv4}>
						<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24"></rect></g><g><g><path d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M7.35,18.5C8.66,17.56,10.26,17,12,17 s3.34,0.56,4.65,1.5C15.34,19.44,13.74,20,12,20S8.66,19.44,7.35,18.5z M18.14,17.12L18.14,17.12C16.45,15.8,14.32,15,12,15 s-4.45,0.8-6.14,2.12l0,0C4.7,15.73,4,13.95,4,12c0-4.42,3.58-8,8-8s8,3.58,8,8C20,13.95,19.3,15.73,18.14,17.12z"></path><path d="M12,6c-1.93,0-3.5,1.57-3.5,3.5S10.07,13,12,13s3.5-1.57,3.5-3.5S13.93,6,12,6z M12,11c-0.83,0-1.5-0.67-1.5-1.5 S11.17,8,12,8s1.5,0.67,1.5,1.5S12.83,11,12,11z"></path></g></g></svg>
					</a>
					<div class="circle-mobile-nav close-menu none-soft circle-effect" on:click={toggleDiv3}>
						<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
					</div>
				</div>
				<div class="col20 f-left circle-image-outer flex justify-center" on:click={toggleDiv2}>
					<div style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)"  class="circle-image"></div>
				</div>
				<div class="col20 f-left circle-sidebar-content-wrapper">
					<div class="col20 f-left flex justify-center mt-15 mb-25 flex-col circle-sidebar-header">
						<h2 class="circle-name col20 f-left">Circle Name</h2>
						<span class="circle-members-info col20 f-left">729 Members</span>
						<span class="circle-description col20 f-left">An optional description about the circle will go in this area.</span>
					</div>

					<!-- Small Icon -->
					<a class="circle-page-item col20 f-left flex align-center">
						<span class="circle-icon small flex-none">
							<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z"/></svg>
						</span>
						<span class="circle-item-name">With Small Icon</span>
						<!-- Item Controls -->
						<div class="circle-page-controls flex align-center justify-center">
							<div class="move-handle circle-round-btn circle-effect">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
							</div>
							<div class="circle-round-btn circle-effect ml-5"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path></svg></div>
						</div>
						<!-- Item Controls END -->
					</a>
					<!-- Small Icon -->

					<!-- Small Icon -->
					<a class="circle-page-item col20 f-left flex align-center">
						<span class="circle-icon small flex-none">
							<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z"/></svg>
						</span>
						<div class="col20">
							<h4 class="circle-item-name flex align-center col20 f-left space-between">
								<span>Group</span>
							</h4>
							<p class="col20 f-left page-description">Description about the video lesson.</p>
						</div>
						<div class="circle-item-footer flex align-center flex-none">
							<span class="circle-badge">New</span>
							<svg class="lock-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g fill="none"><path d="M0 0h24v24H0V0z"></path><path d="M0 0h24v24H0V0z" opacity=".87"></path></g><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"></path></svg>
						</div>
						<!-- Item Controls -->
						<div class="circle-page-controls flex align-center justify-center">
							<div class="move-handle circle-round-btn circle-effect">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
							</div>
							<div class="circle-round-btn circle-effect ml-5"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path></svg></div>
						</div>
						<!-- Item Controls END -->
					</a>
					<!-- Small Icon -->

					<!-- Small Icon -->
					<a class="circle-page-item col20 f-left flex align-center">
						<span class="circle-icon small flex-none">
							<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z"/></svg>
						</span>
						<div class="col20">
							<h4 class="circle-item-name flex align-center col20 f-left space-between">
								<span>Group</span>
							</h4>
							<p class="col20 f-left page-description">Description about the video lesson.</p>
						</div>
						<div class="circle-item-footer flex align-center flex-none">
							<span class="circle-badge">New</span>
							<svg class="lock-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g fill="none"><path d="M0 0h24v24H0V0z"></path><path d="M0 0h24v24H0V0z" opacity=".87"></path></g><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"></path></svg>
							<svg class="complete-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
						</div>
					</a>
					<!-- Small Icon -->

					<!-- Video -->
					<a class="circle-page-item col20 f-left flex align-center">
						<div class="inner-circle-content-thumb-outer">
							<span class="inner-circle-content-thumb" style="background-image: url(&quot;https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg&quot;);"></span>
							<span class="circle-video-play-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M8 5v14l11-7z"></path></svg>
							</span>
						</div>
						<div class="col20">
							<h4 class="circle-item-name flex align-center col20 f-left">
								<span>Video Name</span>
							</h4>
							<p class="col20 f-left page-description">Description about the video lesson.</p>
						</div>
						<div class="circle-item-footer flex-none flex align-center">
							<svg class="complete-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
						</div>
						
					</a>
					<!-- Video -->

					<!-- Small Icon -->
					<a class="circle-page-item col20 f-left flex align-center">
						<span class="circle-icon small flex-none">
							<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z"/></svg>
						</span>
						<div class="col20">
							<h4 class="circle-item-name flex align-center col20 f-left">
								<span>Group Name</span>
							</h4>
							<p class="col20 f-left inner-circle-desc">3/5 Completed</p>
						</div>
						<div class="circle-item-footer flex-none flex align-center">
							<span class="circle-badge">New</span>
							<svg class="complete-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
							<svg class="flex-none inner-circle-toggle-icon arrow-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="m700-300-57-56 84-84H120v-80h607l-83-84 57-56 179 180-180 180Z"/></svg>
						</div>
						
					</a>
					<!-- Small Icon -->

					<!-- Small Icon -->
					<div class="col20 flex align-center flex-col">
						<a class="circle-page-item col20 f-left flex align-center">
							<span class="circle-icon small flex-none">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z"/></svg>
							</span>
							<div class="col20">
								<h4 class="circle-item-name flex align-center col20 f-left">
									<span>Group Name</span>
								</h4>
								<p class="col20 f-left inner-circle-desc">3/5 Completed</p>
							</div>
							<div class="circle-item-footer flex-none flex align-center">
								<svg class="flex-none inner-circle-toggle-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path></svg>
							</div>
						</a>
						<div class="circle-group-navigation col20 f-left">
							<!-- Small Icon -->
							<a class="circle-page-item col20 f-left flex align-center">
								<span class="circle-icon small flex-none">
									1
								</span>
								<div class="col20">
									<h4 class="circle-item-name flex align-center col20 f-left space-between">
										<span>Page</span>
									</h4>
								</div>
								<div class="circle-item-footer flex align-center flex-none">
									<svg class="pending-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
								</div>
							</a>
							<!-- Small Icon -->
							<!-- Small Icon -->
							<a class="circle-page-item col20 f-left flex align-center">
								<span class="circle-icon small flex-none">
									2
								</span>
								<div class="col20">
									<h4 class="circle-item-name flex align-center col20 f-left space-between">
										<span>Page</span>
									</h4>
								</div>
								<div class="circle-item-footer flex align-center flex-none">
									<svg class="pending-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
								</div>
							</a>
							<!-- Small Icon -->
							<!-- Small Icon -->
							<a class="circle-page-item col20 f-left flex align-center">
								<span class="circle-icon small flex-none">
									3
								</span>
								<div class="col20">
									<h4 class="circle-item-name flex align-center col20 f-left space-between">
										<span>Page</span>
									</h4>
								</div>
								<div class="circle-item-footer flex align-center flex-none">
									<svg class="complete-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
								</div>
							</a>
							<!-- Small Icon -->
						</div>
					</div>
					<!-- Small Icon -->
				</div>
			</div>
		</div>
		<div class="circle-content">
			<div class="circle-content-controls">
				<div class="circle-side-controls">
					<a href=""><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 15h2v-3h3v-2h-3V7h-2v3H8v2h3zM21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z"/></svg></a>
					<a href=""><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg></a>
					<a href=""><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M280-280h80v-200h-80v200Zm320 0h80v-400h-80v400Zm-160 0h80v-120h-80v120Zm0-200h80v-80h-80v80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"/></svg></a>
					<a href=""><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/></svg></a>
				</div>
			</div>
			<div class="f-left col20 flex justify-center align-center" style="background: rgb(60, 60, 79); padding-bottom: 40px;">
				<img src="https://static.simvoly.com/images/lms-example.png" class="col20 f-left">
			</div>
		</div>
		<!-- Group Side Naviagation -->
			<div class="circle-group-side-navigation flex-none custom-scroll" class:none-soft={isActive4 || !isVisible}>
				<div class="circle-mobile-nav close-menu none-soft circle-effect" on:click={toggleDiv4}>
					<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
				</div>
				<div class="col20 flex align-center flex-col">
					<div class="circle-page-item col20 f-left flex flex-col">
						<div class="col20">
							<h4 class="circle-item-name circle-group-name flex align-center col20 f-left">
								<span>Group Name</span>
							</h4>
						</div>
						<div class="progress-tracker col20 f-left mt-10 mb-10">
							<p class="col20 f-left inner-circle-desc t-left mb-5">3/5 Completed</p>
							<div class="progress-bar">
			                  	<div class="success-bar" style="width: 50.0%;"></div>
			                </div>
						</div>
					</div>
					<div class="circle-group-navigation col20 f-left">
						<!-- Small Icon -->
						<a class="circle-page-item col20 f-left flex align-center">
							<span class="circle-icon small flex-none">
								1
							</span>
							<div class="col20">
								<h4 class="circle-item-name flex align-center col20 f-left space-between">
									<span>Page</span>
								</h4>
							</div>
							<div class="circle-item-footer flex align-center flex-none">
								<svg class="pending-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
							</div>
						</a>
						<!-- Small Icon -->
						<!-- Small Icon -->
						<a class="circle-page-item col20 f-left flex align-center">
							<span class="circle-icon small flex-none">
								2
							</span>
							<div class="col20">
								<h4 class="circle-item-name flex align-center col20 f-left space-between">
									<span>Page</span>
								</h4>
							</div>
							<div class="circle-item-footer flex align-center flex-none">
								<svg class="pending-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
							</div>
						</a>
						<!-- Small Icon -->
						<!-- Small Icon -->
						<a class="circle-page-item col20 f-left flex align-center">
							<span class="circle-icon small flex-none">
								3
							</span>
							<div class="col20">
								<h4 class="circle-item-name flex align-center col20 f-left space-between">
									<span>Page</span>
								</h4>
							</div>
							<div class="circle-item-footer flex align-center flex-none">
								<svg class="complete-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
							</div>
						</a>
						<!-- Small Icon -->
						<!-- Text Only -->
						<a class="circle-page-item text-only col20 f-left flex align-center">
							<div class="col20">
								<h4 class="circle-item-name flex align-center col20 f-left space-between">
									<span>Text page only</span>
								</h4>
							</div>
							<div class="circle-item-footer flex align-center flex-none">
								<svg class="complete-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
							</div>
						</a>
						<!-- Text Only END -->
						<!-- Text Only -->
						<a class="circle-page-item text-only col20 f-left flex align-center">
							<div class="col20">
								<h4 class="circle-item-name flex align-center col20 f-left space-between">
									<span>Text page only</span>
								</h4>
							</div>
							<div class="circle-item-footer flex align-center flex-none">
								<svg class="complete-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
							</div>
						</a>
						<!-- Text Only END -->

					</div>

					<div class="circle-page-item col20 f-left flex flex-col">
						<div class="col20">
							<h4 class="circle-item-name flex align-center space-between col20 f-left">
								<span>Group Name</span>
								<a href="" class="circle-sidenav-back rounded-btn-effect flex align-center"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"></path></svg>Back</a>
							</h4>
						</div>
						<div class="progress-tracker col20 f-left mt-10 mb-10">
							<p class="col20 f-left inner-circle-desc t-left mb-5">3/5 Completed</p>
							<div class="progress-bar">
			                  	<div class="success-bar" style="width: 50.0%;"></div>
			                </div>
						</div>
					</div>
					<!-- Video -->
					<a class="circle-page-item col20 f-left flex align-center">
						<div class="inner-circle-content-thumb-outer">
							<span class="inner-circle-content-thumb" style="background-image: url(&quot;https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg&quot;);"></span>
							<span class="circle-video-play-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M8 5v14l11-7z"></path></svg>
							</span>
						</div>
						<div class="col20">
							<h4 class="circle-item-name flex align-center col20 f-left">
								<span>Video Name</span>
							</h4>
							<p class="col20 f-left page-description">Description about the video lesson.</p>
						</div>
						<div class="circle-item-footer flex-none flex align-center">
							<svg class="complete-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
						</div>
						
					</a>
					<!-- Video -->
					<!-- Video -->
					<a class="circle-page-item col20 f-left flex align-center">
						<div class="inner-circle-content-thumb-outer">
							<span class="inner-circle-content-thumb" style="background-image: url(&quot;https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg&quot;);"></span>
							<span class="circle-video-play-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M8 5v14l11-7z"></path></svg>
							</span>
						</div>
						<div class="col20">
							<h4 class="circle-item-name flex align-center col20 f-left">
								<span>Video Name</span>
							</h4>
							<p class="col20 f-left page-description">Description about the video lesson.</p>
						</div>
						<div class="circle-item-footer flex-none flex align-center">
							<svg class="complete-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
						</div>
						
					</a>
					<!-- Video -->
					<!-- Video -->
					<a class="circle-page-item col20 f-left flex align-center">
						<div class="inner-circle-content-thumb-outer">
							<span class="inner-circle-content-thumb" style="background-image: url(&quot;https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg&quot;);"></span>
							<span class="circle-video-play-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M8 5v14l11-7z"></path></svg>
							</span>
						</div>
						<div class="col20">
							<h4 class="circle-item-name flex align-center col20 f-left">
								<span>Video Name</span>
							</h4>
							<p class="col20 f-left page-description">Description about the video lesson.</p>
						</div>
						<div class="circle-item-footer flex-none flex align-center">
							<svg class="complete-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
						</div>
						
					</a>
					<!-- Video -->
					<!-- Video -->
					<a class="circle-page-item col20 f-left flex align-center">
						<div class="inner-circle-content-thumb-outer">
							<span class="inner-circle-content-thumb" style="background-image: url(&quot;https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg&quot;);"></span>
							<span class="circle-video-play-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M8 5v14l11-7z"></path></svg>
							</span>
						</div>
						<div class="col20">
							<h4 class="circle-item-name flex align-center col20 f-left">
								<span>Video Name</span>
							</h4>
							<p class="col20 f-left page-description">Description about the video lesson.</p>
						</div>
						<div class="circle-item-footer flex-none flex align-center">
							<svg class="complete-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
						</div>
						
					</a>
					<!-- Video -->

				</div>
			</div>
		<!-- Group Side Naviagation END -->
	</div>
	<!-- CIRCLE LAYOUT 1 END -->

	<!-- Circles Style 2 -->

	<div class="circle-wrapper circle-wrapper-style-2 full-heightt inner-circle-style-2 mt-35" style="margin-top: 55px;">
		<div class="circle-sidebar" style="width:330px;">
			<div class="circle-cover col20 f-left">
				<a href="" class="circle-profile-btn rounded-effect">
					<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24"></rect></g><g><g><path d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M7.35,18.5C8.66,17.56,10.26,17,12,17 s3.34,0.56,4.65,1.5C15.34,19.44,13.74,20,12,20S8.66,19.44,7.35,18.5z M18.14,17.12L18.14,17.12C16.45,15.8,14.32,15,12,15 s-4.45,0.8-6.14,2.12l0,0C4.7,15.73,4,13.95,4,12c0-4.42,3.58-8,8-8s8,3.58,8,8C20,13.95,19.3,15.73,18.14,17.12z"></path><path d="M12,6c-1.93,0-3.5,1.57-3.5,3.5S10.07,13,12,13s3.5-1.57,3.5-3.5S13.93,6,12,6z M12,11c-0.83,0-1.5-0.67-1.5-1.5 S11.17,8,12,8s1.5,0.67,1.5,1.5S12.83,11,12,11z"></path></g></g></svg>
				</a>
			</div>
			<div class="col20 f-left circle-image-outer flex justify-center">
				<div style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)"  class="circle-image"></div>
				<div class="circle-settings-btn-wrapper">
					<a href="" class="middle-button blue f-left">Settings</a>
					<a href="" class="circle-settings-icon ml-5 f-left rounded-effect">
						<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M7 16c.55 0 1 .45 1 1 0 1.1-.9 2-2 2-.17 0-.33-.02-.5-.05.31-.55.5-1.21.5-1.95 0-.55.45-1 1-1M18.67 3c-.26 0-.51.1-.71.29L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41l-1.34-1.34c-.2-.2-.45-.29-.7-.29zM7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3z"/></svg>
					</a>
				</div>
			</div>
			<div class="col20 f-left flex justify-center mt-15 mb-25 flex-col">
				<h2 class="circle-name col20 f-left">Circle Name</h2>
				<span class="circle-members-info col20 f-left">729 Members</span>
				<span class="circle-description col20 f-left">An optional description about the circle will go in this area.</span>
			</div>
			<div class="inner-circles-wrapper-outer col20 f-left border-design">
				<div class="circle-starting-sections col20 f-left">
					<!-- Text Only -->
					<a class="circle-page-item text-only col20 f-left flex align-center">
						<span class="circle-item-name">Text Only</span>
						<div class="circle-page-controls">
							<div class="circle-round-btn circle-effect"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg></div>
							<div class="move-handle circle-round-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
							</div>
						</div>
					</a>
					<!-- Text Only -->
					<!-- Small Icon -->
					<a class="circle-page-item col20 f-left flex align-center">
						<span class="circle-icon small flex-none">
							<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z"/></svg>
						</span>
						<span class="circle-item-name">With Small Icon</span>
						<div class="circle-page-controls">
							<div class="circle-round-btn circle-effect"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg></div>
							<div class="move-handle circle-round-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
							</div>
						</div>
					</a>
					<!-- Small Icon -->
					<!-- Small with Number -->
					<a class="circle-page-item col20 f-left flex align-center">
						<span class="circle-icon small flex-none">
							1
						</span>
						<span class="circle-item-name">Small With A Number <span class="circle-badge">New</span></span>
						<div class="circle-page-controls">
							<div class="circle-round-btn circle-effect"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg></div>
							<div class="move-handle circle-round-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
							</div>
						</div>
					</a>
					<!-- Small with Number -->
					<!-- Big with Number -->
					<a class="circle-page-item col20 f-left flex align-center">
						<span class="circle-icon big flex-none">
							2
						</span>
						<span class="content-text-wrapper">
							<h4 class="col20 f-left circle-item-name">With Big Icon <svg class="lock-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g fill="none"><path d="M0 0h24v24H0V0z"/><path d="M0 0h24v24H0V0z" opacity=".87"/></g><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/></svg></h4>
							<p class="col20 f-left page-description">Description about the video lesson.</p>
						</span>
						<div class="circle-page-controls">
							<div class="circle-round-btn circle-effect"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg></div>
							<div class="move-handle circle-round-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
							</div>
						</div>
					</a>
					<!-- Big with Number -->
					<!-- Big Icon -->
					<a class="circle-page-item col20 f-left flex align-center">
						<span class="circle-icon big flex-none">
							<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z"/></svg>
						</span>
						<span class="content-text-wrapper">
							<h4 class="col20 f-left circle-item-name">With Big Icon <span class="circle-badge">New</span></h4>
							<p class="col20 f-left page-description">Description about the video lesson.</p>
						</span>
						<div class="circle-page-controls">
							<div class="circle-round-btn circle-effect"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg></div>
							<div class="move-handle circle-round-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
							</div>
						</div>
					</a>
					<!-- Big Icon -->
					<!-- Image/Video Small -->
					<a href="" class="circle-page-item flex align-center col20">
						<div class="inner-circle-content-thumb-outer small">
							<span class="inner-circle-content-thumb" style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)">
							</span>
						</div>
						<span class="content-text-wrapper">
							<h4 class="f-left circle-item-name">With Small Image  <svg class="complete-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg></h4>
						</span>
						<div class="circle-page-controls">
							<div class="circle-round-btn circle-effect"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg></div>
							<div class="move-handle circle-round-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
							</div>
						</div>
					</a>
					<!-- Image/Video Small -->
					<!-- Image -->
					<a href="" class="circle-page-item flex align-center col20 f-left complete">
						<div class="inner-circle-content-thumb-outer">
							<span class="inner-circle-content-thumb" style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)">
							</span>
						</div>
						<span class="content-text-wrapper">
							<div class="circle-item-name-wrapper">
								<h4 class="f-left circle-item-name">
									With Image
									<svg class="complete-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg>
									<span class="circle-badge">New</span>
								</h4>
							</div>
						</span>
						<div class="circle-page-controls">
							<div class="circle-round-btn circle-effect"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg></div>
							<div class="move-handle circle-round-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
							</div>
						</div>
					</a>
					<!-- Image -->
					<!-- Video -->
					<a href="" class="circle-page-item flex align-center col20 f-left complete option-video-lesson">
						<div class="inner-circle-content-thumb-outer">
							<span class="inner-circle-content-thumb" style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)">
							</span>
							<span class="circle-video-play-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M8 5v14l11-7z"/></svg>
							</span>
						</div>
						<span class="content-text-wrapper">
							<h4 class="col20 f-left circle-item-name">With Video</h4>
						</span>
						<div class="circle-page-controls">
							<div class="circle-round-btn circle-effect"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg></div>
							<div class="move-handle circle-round-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
							</div>
						</div>
					</a>
					<!-- Video -->
					<!-- Video/Image Locked -->
					<a href="" class="circle-page-item flex align-center col20 f-left completee active option-video-lesson">
						<div class="inner-circle-content-thumb-outer">
							<span class="inner-circle-content-thumb blurred" style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)">
							</span>
							<span class="circle-video-play-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g fill="none"><path d="M0 0h24v24H0V0z"/><path d="M0 0h24v24H0V0z" opacity=".87"/></g><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/></svg>
							</span>
						</div>
						<div class="content-text-wrapper">
							<h4 class="col20 f-left circle-item-name">Image/Video Locked</h4>
							<p class="col20 f-left inner-circle-desc">Description about the video lesson.</p>
						</div>
						<div class="circle-page-controls">
							<div class="circle-round-btn circle-effect"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg></div>
							<div class="move-handle circle-round-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
							</div>
						</div>
					</a>
					<!-- Video/Image Locked -->
				</div>

				<!-- Inner Circle Wrapper -->
				<div class="inner-circle-wrapper col20 f-left mt-10">
					<div class="inner-circle-header flex align-center">
						<span class="circle-icon flex-none"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M7 16c.55 0 1 .45 1 1 0 1.1-.9 2-2 2-.17 0-.33-.02-.5-.05.31-.55.5-1.21.5-1.95 0-.55.45-1 1-1M18.67 3c-.26 0-.51.1-.71.29L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41l-1.34-1.34c-.2-.2-.45-.29-.7-.29zM7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3z"></path></svg></span>
						<div class="inner-circle-name flex space-between align-center">
							<span>
								<h4 class="col20 f-left inner-circle-title">Inner Circle Name</h4>
								<p class="col20 f-left inner-circle-desc">3/5 Completed</p>
							</span>
							<svg class="flex-none inner-circle-toggle-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
							<div class="inner-circle-settings">
								<div class="circle-round-btn circle-effect"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg></div>
								<div class="move-handle circle-round-btn">
									<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
								</div>
							</div>
						</div>
					</div>
					<div class="col20 f-left inner-circle-pages-wrapper">
						<!-- Video -->
						<a href="" class="circle-page-item flex align-center col20 f-left complete option-video-lesson">
							<div class="inner-circle-content-thumb-outer">
								<span class="inner-circle-content-thumb" style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)">
								</span>
								<span class="circle-video-play-btn">
									<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M8 5v14l11-7z"/></svg>
								</span>
							</div>
							<span class="content-text-wrapper">
								<h4 class="col20 f-left circle-item-name">With Video</h4>
							</span>
							<div class="circle-page-controls">
								<div class="circle-round-btn circle-effect"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg></div>
								<div class="move-handle circle-round-btn">
									<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
								</div>
							</div>
						</a>
						<!-- Video -->
						<a href="" class="f-left with-icon small-button blue circle-effect">Add A Page</a>
					</div>
				</div>
				<!-- Inner Circle Wrapper  END-->

				<div class="inner-circle-wrapper col20 f-left mt-10">
					<a href="" class="inner-circle-name flex space-between align-center">
						<span>
							<h4 class="col20 f-left inner-circle-title">Inner Circle Name</h4>
							<p class="col20 f-left inner-circle-desc">3/5 Completed</p>
						</span>
						<svg class="flex-none inner-circle-toggle-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
						<div class="inner-circle-settings">
							<div class="circle-round-btn circle-effect"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg></div>
							<div class="move-handle circle-round-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
							</div>
						</div>
					</a>
				</div>
				<!--
				<div class="inner-circle-wrapper col20 f-left mt-10">
					<a href="" class="inner-circle-name flex space-between align-center">
						<span>
							<h4 class="col20 f-left inner-circle-title">Inner Circle Name</h4>
						</span>
						<a href="" class="circle-sidenav-view rounded-btn-effect flex align-center">
							View
							<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><rect fill="none" height="24" width="24"/><path d="M15,5l-1.41,1.41L18.17,11H2V13h16.17l-4.59,4.59L15,19l7-7L15,5z"/></svg>
						</a>
					</a>
				</div>-->
				<div class="inner-circle-wrapper col20 f-left mt-10">
					<a href="" class="inner-circle-name flex space-between align-center">
						<div class="flex align-center">
							<span class="circle-icon flex-none">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M7 16c.55 0 1 .45 1 1 0 1.1-.9 2-2 2-.17 0-.33-.02-.5-.05.31-.55.5-1.21.5-1.95 0-.55.45-1 1-1M18.67 3c-.26 0-.51.1-.71.29L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41l-1.34-1.34c-.2-.2-.45-.29-.7-.29zM7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3z"></path></svg>
							</span>
							<span>
								<h4 class="col20 f-left inner-circle-title">Inner Circle Name</h4>
								<p class="col20 f-left inner-circle-desc">Description about the Inner Circle content</p>
							</span>
						</div>
						<svg class="flex-none inner-circle-toggle-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
						<div class="inner-circle-settings">
							<div class="circle-round-btn circle-effect"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg></div>
							<div class="move-handle circle-round-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
							</div>
						</div>
					</a>
				</div>
				<div class="inner-circle-wrapper col20 f-left mt-10">
					<a href="" class="inner-circle-name flex space-between align-center">
						<div class="flex align-center">
							<span class="circle-icon small flex-none">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M11 15h2v-3h3v-2h-3V7h-2v3H8v2h3zM21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z"></path></svg>
							</span>
							<span>
								<h4 class="col20 f-left inner-circle-title">Inner Circle Name <span class="circle-badge">New</span></h4>
							</span>
						</div>
						<svg class="flex-none inner-circle-toggle-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
						<div class="inner-circle-settings">
							<div class="circle-round-btn circle-effect"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg></div>
							<div class="move-handle circle-round-btn">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
							</div>
						</div>
					</a>
				</div>
				<div class="col20 f-left mt-15">
					<a href="" class="middle-button blue with-icon">Create New</a>
				</div>
			</div>
		</div>
		<div class="circle-content">
			<div class="circle-content-controls">
				<div class="circle-top-controls">
					<a href="" >Editor</a>
					<a href="" class="active">Analytics</a>
				</div>
				<div class="circle-side-controls">
					<a href=""><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 15h2v-3h3v-2h-3V7h-2v3H8v2h3zM21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z"/></svg></a>
					<a href=""><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg></a>
					<a href=""><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/></svg></a>
				</div>
			</div>
			<div class="sections-wrapper profile-inner-wrapper f-left col20" style="margin-bottom: 60px;">
				<div class="top-background circle-page-analytics-head f-left col20 flex space-between align-center">
					<div class="text-wrapper flex align-center flex-col-mobile align-left-mobile col20 f-left">
						<h1 class="members-title f-left t-center" style="margin-bottom: 0px;">Page Analytics</h1>
						<div class="flex align-center">
							<div class="f-left">
								<div class="custom-dropdown">
									<div class="flex align-center custom-dropdown-button circle-effect"><span class="material-icons date-range-icon">date_range</span> Last 7 days <span class="material-icons">keyboard_arrow_down</span></div>
								</div>
							</div>
						</div>
					</div>
					<div class="upper-navigation upper-navigation-full flex-none">
						<ul>
							<li><a class="active">Overview</a></li>
							<li><a class="">Sales</a></li>
						</ul>
					</div>
				</div>

				<div class="col20 f-left">
					<div class="padding-45 f-left col20" style="padding-top: 25px;">
						<div class="flex col20 f-left store-section-analytics-warapper narrow-analytics-boxes flex-col-mobile" style="margin-top: 0px;">
							<div class="analytics-box analytics-box-small col5">
								<h3 class="flex align-center">Unique Visitors <span class="chart-color ml-10" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span></h3>
								<h2 class="col20 f-left f-28 gray-text"><b>845</b></h2>
							</div>
							<div class="analytics-box analytics-box-small col5">
								<h3 class="flex align-center">
									Completed
									<span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">
				            info
				            <span class="none-soft hidden-info">
				              <h4>Cancelations (Churn)</h4>
				              <span>The total amount of subscriptions that were cancelled in the selected period.</span>
				            </span>
				          </span>
									<span class="chart-color ml-10" style="background: #76bd65"></span>
								</h3>
								<h2 class="col20 f-left f-28 gray-text"><b>236 <span class="increase">(33.3%)</span></b></h2>
							</div>
							<div class="analytics-box analytics-box-small">
								<h3 class="flex align-center">
									In Progress
									<span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">
				            info
				            <span class="none-soft hidden-info">
				              <h4>Monthly Recurring Revenue</h4>
				              <span>New MRR shows how much new monthly recurring revenue was acquired in the selected period.</span>
				            </span>
				          </span>
									<span class="chart-color ml-10" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>
								</h3>
								<h2 class="col20 f-left f-28 gray-text"><b>578 <span class="increase">(53.3%)</span></b></h2>
							</div>
							<div class="analytics-box analytics-box-small col5">
								<h3 class="flex align-center">
									Revenue
									<span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">
				            info
				            <span class="none-soft hidden-info">
				              <h4>Revenue</h4>
				              <span>The revenue that came from renewals and new subscriptions combined.</span>
				            </span>
				          </span>
								</h3>
								<h2 class="col20 f-left f-28 gray-text"><b>$265.00</b>
									<span class="col20 f-left mt-5" style="margin-left: 0px; opacity: 0.7;">28 Paying Members</span>
								</h2>
							</div>
						</div>
						<div class="flex f-left col20 mt-25 flex-col-mobile">
							<div class="analytics-box-big col20 no-bpadding-mobile">
								<h2 class="col20 f-left f-28 gray-text">Members and Revenue</h2>
								<div class="col20 f-left relative mt-25 modern-chart-box">
									<canvas style="display: block; box-sizing: border-box; height: 330px; width: 660px;" width="660" height="330"></canvas>
									<div class="axis">
										<div class="tick"><span class="tick-label">27 May</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
										<div class="tick"><span class="tick-label">28 May</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
										<div class="tick"><span class="tick-label">29 May</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$20.00</span> </div>
										<div class="tick"><span class="tick-label">30 May</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
										<div class="tick"><span class="tick-label">31 May</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
										<div class="tick"><span class="tick-label">1 Jun</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
										<div class="tick"><span class="tick-label">2 Jun</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>

	<!-- End of style 2 -->


	<!-- Circles Style 2 -->

	<div class="circle-wrapper circle-wrapper-style-2 mt-35" >
		<div class="circle-sidebar" style="width:340px;">
			<div class="circle-cover col20 f-left">

			</div>
			<div class="col20 f-left circle-image-outer flex justify-center">
				<div style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)"  class="circle-image"></div>
				<div class="circle-settings-btn-wrapper">
					<a href="" class="middle-button blue f-left">Settings</a>
					<a href="" class="circle-settings-icon ml-5 f-left rounded-effect">
						<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M7 16c.55 0 1 .45 1 1 0 1.1-.9 2-2 2-.17 0-.33-.02-.5-.05.31-.55.5-1.21.5-1.95 0-.55.45-1 1-1M18.67 3c-.26 0-.51.1-.71.29L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41l-1.34-1.34c-.2-.2-.45-.29-.7-.29zM7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3z"/></svg>
					</a>
				</div>
			</div>
			<div class="col20 f-left flex justify-center mt-15 mb-25 flex-col">
				<h2 class="circle-name col20 f-left">Circle Name</h2>
				<span class="circle-members-info col20 f-left">729 Members</span>
			</div>
			<div class="inner-circles-wrapper-outer col20 f-left">
				<!--<div class="circle-starting-sections col20 f-left">
					<a class="circle-page-item col20 f-left flex align-center">
						<span class="circle-icon flex-none">
							<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z"/></svg>
						</span>
						<span class="circle-item-name">Feed</span>
					</a>
					<a class="circle-page-item col20 f-left flex align-center">
						<span class="circle-icon flex-none">
							<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z"/></svg>
						</span>
						<span class="circle-item-name">Explore</span>
					</a>
				</div>-->
				<div class="inner-circle-wrapper col20 f-left mt-10">
					<a href="" class="inner-circle-name flex space-between align-center">
						<span>
							<h4 class="col20 f-left inner-circle-title">Inner Circle Name</h4>
							<p class="col20 f-left inner-circle-desc">3/5 Completed</p>
						</span>
						<a href="" class="circle-sidenav-back rounded-btn-effect flex align-center">
							<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"/></svg>
							Back
						</a>
					</a>
					<ul class="col20 f-left inner-circle-pages-wrapper border-design">
						<li class="option-video-lesson">
							<a href="" class="flex align-center col20 f-left complete">
								<div class="inner-circle-content-thumb-outer">
									<span class="inner-circle-content-thumb" style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)">
									</span>
									<span class="circle-video-play-btn">
										<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M8 5v14l11-7z"/></svg>
									</span>
								</div>
								<span class="content-text-wrapper">
									<h4 class="col20 f-left circle-item-name">Video Lesson Name</h4>
								</span>
							</a>
						</li>
						<li class="option-video-lesson">
							<a href="" class="flex align-center col20 f-left completee active">
								<div class="inner-circle-content-thumb-outer">
									<span class="inner-circle-content-thumb blurred" style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)">
									</span>
									<span class="circle-video-play-btn">
										<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
									</span>
								</div>
								<div class="content-text-wrapper">
									<h4 class="col20 f-left circle-item-name">Video Lesson Name</h4>
									<p class="col20 f-left inner-circle-desc">Description about the video lesson.</p>
								</div>
							</a>
						</li>
						<li class="option-video-lesson">
							<a href="" class="flex align-center col20 f-left completee active">
								<div class="inner-circle-content-thumb-outer">
									<span class="inner-circle-content-thumb blurred" style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)">
									</span>
									<span class="circle-video-play-btn">
										<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g fill="none"><path d="M0 0h24v24H0V0z"/><path d="M0 0h24v24H0V0z" opacity=".87"/></g><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/></svg>
									</span>
								</div>
								<div class="content-text-wrapper">
									<h4 class="col20 f-left circle-item-name">Video Lesson Name</h4>
									<p class="col20 f-left inner-circle-desc">Description about the video lesson.</p>
								</div>
							</a>
						</li>
						<li class="option-video-lesson">
							<a href="" class="flex align-center col20 f-left completee active">
								<div class="inner-circle-content-thumb-outer">
									<span class="inner-circle-content-thumb blurred" style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)">
									</span>
									<span class="circle-video-play-btn">
										<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g fill="none"><path d="M0 0h24v24H0V0z"/><path d="M0 0h24v24H0V0z" opacity=".87"/></g><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/></svg>
									</span>
								</div>
								<div class="content-text-wrapper">
									<h4 class="col20 f-left circle-item-name">Video Lesson Name</h4>
									<p class="col20 f-left inner-circle-desc">Description about the video lesson.</p>
								</div>
							</a>
						</li>
						<li class="option-video-lesson">
							<a href="" class="flex align-center col20 f-left completee active">
								<div class="inner-circle-content-thumb-outer">
									<span class="inner-circle-content-thumb blurred" style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)">
									</span>
									<span class="circle-video-play-btn">
										<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g fill="none"><path d="M0 0h24v24H0V0z"/><path d="M0 0h24v24H0V0z" opacity=".87"/></g><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/></svg>
									</span>
								</div>
								<div class="content-text-wrapper">
									<h4 class="col20 f-left circle-item-name">Video Lesson Name</h4>
									<p class="col20 f-left inner-circle-desc">Description about the video lesson.</p>
								</div>
							</a>
						</li>
						<li class="option-video-lesson">
							<a href="" class="flex align-center col20 f-left completee active">
								<div class="inner-circle-content-thumb-outer">
									<span class="inner-circle-content-thumb blurred" style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)">
									</span>
									<span class="circle-video-play-btn">
										<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g fill="none"><path d="M0 0h24v24H0V0z"/><path d="M0 0h24v24H0V0z" opacity=".87"/></g><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/></svg>
									</span>
								</div>
								<div class="content-text-wrapper">
									<h4 class="col20 f-left circle-item-name">Video Lesson Name</h4>
									<p class="col20 f-left inner-circle-desc">Description about the video lesson.</p>
								</div>
							</a>
						</li>
						<li>
							<a class="circle-page-item col20 f-left flex align-center">
								<span class="circle-icon flex-none">
									<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z"/></svg>
								</span>
								<span class="circle-item-name">Getting Started</span>
							</a>
						</li>
						<li>
							<a href="" class="f-left with-icon small-button blue circle-effect">Add A Page To This Section</a>
						</li>
						<!--<li>
							<a href="" class="middle-button blue with-icon">Add Page</a>
						</li>-->
					</ul>
				</div>
			</div>
		</div>
		<div class="circle-content">
			<div class="circle-page-header col20 f-left">
				<div class="circle-page-header-inner flex align-center space-between">
					<div class="flex align-center">
						<span class="circle-icon flex-none"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M7 16c.55 0 1 .45 1 1 0 1.1-.9 2-2 2-.17 0-.33-.02-.5-.05.31-.55.5-1.21.5-1.95 0-.55.45-1 1-1M18.67 3c-.26 0-.51.1-.71.29L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41l-1.34-1.34c-.2-.2-.45-.29-.7-.29zM7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3z"></path></svg></span>
						<div>
							<div class="flex align-cnter f-left col20">
								<h3>The Name Of The Page</h3>
								<div class="reaction-button white-background not-button flex align-center f-left ml-15">
									<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24"></rect></g><g><g><path d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M7.35,18.5C8.66,17.56,10.26,17,12,17 s3.34,0.56,4.65,1.5C15.34,19.44,13.74,20,12,20S8.66,19.44,7.35,18.5z M18.14,17.12L18.14,17.12C16.45,15.8,14.32,15,12,15 s-4.45,0.8-6.14,2.12l0,0C4.7,15.73,4,13.95,4,12c0-4.42,3.58-8,8-8s8,3.58,8,8C20,13.95,19.3,15.73,18.14,17.12z"></path><path d="M12,6c-1.93,0-3.5,1.57-3.5,3.5S10.07,13,12,13s3.5-1.57,3.5-3.5S13.93,6,12,6z M12,11c-0.83,0-1.5-0.67-1.5-1.5 S11.17,8,12,8s1.5,0.67,1.5,1.5S12.83,11,12,11z"></path></g></g></svg>
									<span>1,682 Members</span>
								</div>
							</div>
							<div class="col20 f-left page-description-inner">A description about the group/page will display here...</div>
						</div>
					</div>
					<div>
						<div class="circle-post-share flex align-center circle-effect primaryColor-bg2"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"></path></svg> <span>Share</span></div>
					</div>
				</div>
			</div>
			<div class="f-left col20 flex justify-center align-center" style="background: #3c3c4f; padding-bottom: 40px;">
				<img src="https://static.simvoly.com/images/lms-example.png" class="col20 f-left">
			</div>


			<div class="col20 f-left" style="margin-top: -30px;">
				<div class="circle-posts-list" >

					<!-- Start A Post -->

					<div class="col20 f-left circle-post-start flex flex-row">
						<div class="circle-post-author-image flex-none" style="background-image:url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg);"></div>
						<div class="circle-post-start-inner">
							<span class="circle-post-starter col20 f-left">Start a new post</span>
							<div class="col20 f-left circle-post-types">
								<div class="reaction-button flex align-center circle-effect f-left ml-5">
									<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"/></svg>
									<span>Image</span>
								</div>
								<div class="reaction-button flex align-center circle-effect f-left ml-5">
									<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/></svg>
									<span>Video</span>
								</div>
								<div class="reaction-button flex align-center circle-effect f-left ml-5">
									<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><path d="M0,0h24v24H0V0z" fill="none"/></g><g><path d="M4,6H2v14c0,1.1,0.9,2,2,2h14v-2H4V6z M20,2H8C6.9,2,6,2.9,6,4v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V4 C22,2.9,21.1,2,20,2z M20,16H8V4h12V16z M13.51,10.16c0.41-0.73,1.18-1.16,1.63-1.8c0.48-0.68,0.21-1.94-1.14-1.94 c-0.88,0-1.32,0.67-1.5,1.23l-1.37-0.57C11.51,5.96,12.52,5,13.99,5c1.23,0,2.08,0.56,2.51,1.26c0.37,0.6,0.58,1.73,0.01,2.57 c-0.63,0.93-1.23,1.21-1.56,1.81c-0.13,0.24-0.18,0.4-0.18,1.18h-1.52C13.26,11.41,13.19,10.74,13.51,10.16z M12.95,13.95 c0-0.59,0.47-1.04,1.05-1.04c0.59,0,1.04,0.45,1.04,1.04c0,0.58-0.44,1.05-1.04,1.05C13.42,15,12.95,14.53,12.95,13.95z"/></g></svg>
									<span>Survey</span>
								</div>
								<div class="reaction-button flex align-center circle-effect f-left ml-5">
									<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none"/><path d="M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm-2 1.13L7.92 12H2V6.21l1.93-1.93L3.36 7H10v.13zM22.5 10h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5zm-.5 7.79l-1.93 1.93.57-2.72H14v-.13L16.08 12H22v5.79z"/></svg>
									<span>Vote</span>
								</div>
							</div>
						</div>
					</div>

					<!-- Post -->

					<div class="circle-post-wrapper col20 f-left mt-35 mb-15">
						<header class="col20 f-lef flex align-center space-between">
							<div class="flex align-center">
								<div class="circle-post-author flex align-center">
									<div class="circle-post-author-image" style="background-image:url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg);"></div>
									<span class="circle-post-author-name">Stan Petrov</span>
									<span class="circle-post-time">1:17PM, 17 Dec</span>
								</div>
								<div class="circle-post-badge moderator">Dragon</div>
							</div>
							<div class="circle-round-btn circle-effect">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
							</div>
						</header>
						<div class="col20 f-left circle-post-content">
							<h1 class="col20 f-left circle-post-content-title">Headline for the First Circle Post</h1>
							<span class="col20 f-left circle-post-content-paragraph">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</span>
						</div>
						<div class="col20 f-left circle-post-footer flex align-center space-between">
							<div class="circle-post-footer-left flex align-center">
								<div class="reaction-icon reaction-icon-post circle-round-btn circle-effect f-left">
									<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"/></svg>
								</div>
								<div class="reaction-wrapper flex align-center active">
									<div class="reaction-icon circle-round-btn circle-effect f-left">
										<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"/></svg>
									</div>
									<div class="reaction-icon circle-round-btn circle-effect f-left small-reaction">
										<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" opacity=".87"/><path d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.58-6.59c.37-.36.59-.86.59-1.41V5c0-1.1-.9-2-2-2zm0 12l-4.34 4.34L11.77 14H3v-2l3-7h9v10zm4-12h4v12h-4z"/></svg>
									</div>
									<span>1,729</span>
								</div>
								<div class="circle-post-share flex align-center circle-effect">
									<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/></svg>
									<span>Share</span>
								</div>
							</div>
							<div class="circle-post-footer-comments-btn flex align-center circle-effect">
								72 Comments
							</div>
						</div>
						<div class="circle-post-reply-wrapper col20 f-left">
							<div class="col20 f-left circle-post-reply flex align-center">
								<div class="circle-post-author-image" style="background-image:url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg);"></div>
								<div class="circle-post-comment-input">Write your answer here...</div>
							</div>
						</div>
						<div class="circle-post-comments-wrapper col20 f-left">
							<div class="circle-post-comment f-left col20">
								<header class="col20 f-lef flex align-center space-between">
									<div class="flex align-center">
										<div class="circle-post-author flex align-center">
											<div class="circle-post-author-image" style="background-image:url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg);"></div>
											<span class="circle-post-author-name">Stan Petrov</span>
											<span class="circle-post-time">1:17PM, 17 Dec</span>
										</div>
										<div class="circle-post-badge moderator">Newbie</div>
									</div>
									<div class="circle-round-btn circle-effect">
										<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
									</div>
								</header>
								<div class="col20 f-left circle-post-content">
									<div class="circle-comment-content col20 f-left">
										<span class="col20 f-left circle-post-content-paragraph">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</span>
										<div class="comment-footer col20 f-left flex align-center">
											<div class="reaction-icon circle-round-btn circle-effect f-left">
												<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"/></svg>
											</div>
											<div class="reaction-wrapper flex align-center active">
												<div class="reaction-icon circle-round-btn circle-effect f-left">
													<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"/></svg>
												</div>
												<span>89</span>
											</div>
											<div class="circle-post-share flex align-center circle-effect">
												<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"/></svg>
												<span>Reply</span>
											</div>
											<span class="comment-replies-count flex align-center">13 Replies</span>
										</div>
									</div>
									<!-- Comment Replies-->
									<div class="circle-comments-reply-wrapper col20 f-left">
										<div class="circle-post-comment f-left col20">
											<header class="col20 f-lef flex align-center space-between">
												<div class="flex align-center">
													<div class="circle-post-author flex align-center">
														<div class="circle-post-author-image" style="background-image:url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg);"></div>
														<span class="circle-post-author-name">Stan Petrov</span>
														<span class="circle-post-time">1:17PM, 17 Dec</span>
													</div>
												</div>
												<div class="circle-round-btn circle-effect">
													<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
												</div>
											</header>
											<div class="col20 f-left circle-post-content">
												<div class="circle-comment-content col20 f-left">
													<span class="col20 f-left circle-post-content-paragraph">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</span>
													<div class="comment-footer col20 f-left flex align-center">
														<div class="reaction-icon circle-round-btn circle-effect f-left">
															<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"/></svg>
														</div>
														<div class="circle-post-share flex align-center circle-effect">
															<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"/></svg>
															<span>Reply</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<!-- Comment Replies-->
								</div>
							</div>

							<div class="circle-post-comment f-left col20">
								<header class="col20 f-lef flex align-center space-between">
									<div class="flex align-center">
										<div class="circle-post-author flex align-center">
											<div class="circle-post-author-image" style="background-image:url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg);"></div>
											<span class="circle-post-author-name">Stan Petrov</span>
											<span class="circle-post-time">1:17PM, 17 Dec</span>
										</div>
										<div class="circle-post-badge moderator">Badge</div>
									</div>
									<div class="circle-round-btn circle-effect">
										<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
									</div>
								</header>
								<div class="col20 f-left circle-post-content">
									<div class="circle-comment-content col20 f-left">
										<span class="col20 f-left circle-post-content-paragraph">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span>
										<div class="comment-footer col20 f-left flex align-center">
											<div class="reaction-icon circle-round-btn circle-effect f-left">
												<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"/></svg>
											</div>
											<div class="circle-post-share flex align-center circle-effect">
												<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"/></svg>
												<span>Reply</span>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="circle-post-footer-comments-btn circle-effect f-left">
								Load More Comments
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Kanban -->
			<div class="col20 f-left kanban-wrapper course-kanban">
				<div class="kanban-column">
					<header class="col20 f-left flex align-center space-between kanban-header">
						<div class="flex align-center col20">
							<h3 class="kanban-column-title">To Learn</h3>
							<div class="kanban-column-count">8</div>
						</div>
						<a href="" class="kanban-column-settings">
							<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path></svg>
						</a>
					</header>
					<div class="f-left col20">
						<div class="kanban-item">
							<h3 class="kanban-item-title f-left col20">Kanban Item Name</h3>
							<span class="kanban-item-description f-left col20">A description about the Circle Content in the Kanban view</span>
						</div>
						<div class="kanban-item with-image">
							<div class="inner-circle-content-thumb-outer mb-15">
								<span class="inner-circle-content-thumb" style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)">
								</span>
								<span class="circle-video-play-btn">
									<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M8 5v14l11-7z"/></svg>
								</span>
							</div>
							<h3 class="kanban-item-title f-left col20">Kanban Item Name</h3>
							<span class="kanban-item-description f-left col20">A description about the Circle Content in the Kanban view</span>
						</div>
						<div class="kanban-item with-image">
							<div class="inner-circle-content-thumb-outer mb-15">
								<span class="inner-circle-content-thumb blurred" style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)">
								</span>
								<span class="circle-video-play-btn">
									<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g fill="none"><path d="M0 0h24v24H0V0z"/><path d="M0 0h24v24H0V0z" opacity=".87"/></g><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/></svg>
								</span>
							</div>
							<h3 class="kanban-item-title f-left col20">Kanban Item Name</h3>
							<span class="kanban-item-description f-left col20">A description about the Circle Content in the Kanban view</span>
						</div>
					</div>
				</div>

				<div class="kanban-column">
					<header class="col20 f-left flex align-center space-between kanban-header">
						<div class="flex align-center col20">
							<h3 class="kanban-column-title">In Progress</h3>
							<div class="kanban-column-count">3</div>
						</div>
						<a href="" class="kanban-column-settings">
							<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path></svg>
						</a>
					</header>
					<div class="f-left col20">
						<div class="kanban-item with-image">
							<div class="inner-circle-content-thumb-outer mb-15">
								<span class="inner-circle-content-thumb" style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)">
								</span>
								<span class="circle-video-play-btn">
									<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M8 5v14l11-7z"/></svg>
								</span>
							</div>
							<h3 class="kanban-item-title f-left col20">Kanban Item Name</h3>
							<span class="kanban-item-description f-left col20">A description about the Circle Content in the Kanban view</span>
						</div>
						<div class="kanban-item">
							<h3 class="kanban-item-title f-left col20">Kanban Item Name</h3>
							<span class="kanban-item-description f-left col20">A description about the Circle Content in the Kanban view</span>
						</div>
					</div>
				</div>

				<div class="kanban-column">
					<header class="col20 f-left flex align-center space-between kanban-header">
						<div class="flex align-center col20">
							<h3 class="kanban-column-title">Completed</h3>
							<div class="kanban-column-count">2</div>
						</div>
						<a href="" class="kanban-column-settings">
							<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path></svg>
						</a>
					</header>
					<div class="f-left col20">
						<div class="kanban-item with-image">
							<div class="inner-circle-content-thumb-outer mb-15">
								<span class="inner-circle-content-thumb" style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)">
								</span>
								<span class="circle-video-play-btn">
									<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M8 5v14l11-7z"/></svg>
								</span>
							</div>
							<h3 class="kanban-item-title f-left col20">Kanban Item Name</h3>
							<span class="kanban-item-description f-left col20">A description about the Circle Content in the Kanban view</span>
						</div>
						<div class="kanban-item with-image">
							<div class="inner-circle-content-thumb-outer mb-15">
								<span class="inner-circle-content-thumb" style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)">
								</span>
								<span class="circle-video-play-btn">
									<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M8 5v14l11-7z"/></svg>
								</span>
							</div>
							<h3 class="kanban-item-title f-left col20">Kanban Item Name</h3>
							<span class="kanban-item-description f-left col20">A description about the Circle Content in the Kanban view</span>
						</div>
					</div>
				</div>
			</div>

			<!-- Kanban -->


		</div>
	</div>

	<!-- End of style 2 -->



	<!-- Circles Style 2 -->

	<div class="circle-wrapper circle-wrapper-style-2 mt-35">
		<div class="circle-sidebar" style="width:400px;">
			<div class="circle-cover col20 f-left">
				<a href="" class="circle-profile-btn rounded-effect">
					<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24"></rect></g><g><g><path d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M7.35,18.5C8.66,17.56,10.26,17,12,17 s3.34,0.56,4.65,1.5C15.34,19.44,13.74,20,12,20S8.66,19.44,7.35,18.5z M18.14,17.12L18.14,17.12C16.45,15.8,14.32,15,12,15 s-4.45,0.8-6.14,2.12l0,0C4.7,15.73,4,13.95,4,12c0-4.42,3.58-8,8-8s8,3.58,8,8C20,13.95,19.3,15.73,18.14,17.12z"></path><path d="M12,6c-1.93,0-3.5,1.57-3.5,3.5S10.07,13,12,13s3.5-1.57,3.5-3.5S13.93,6,12,6z M12,11c-0.83,0-1.5-0.67-1.5-1.5 S11.17,8,12,8s1.5,0.67,1.5,1.5S12.83,11,12,11z"></path></g></g></svg>
				</a>
			</div>
			<div class="col20 f-left circle-image-outer flex justify-center">
				<div style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)"  class="circle-image"></div>
				<div class="circle-settings-btn-wrapper">
					<a href="" class="middle-button blue f-left">Settings</a>
					<a href="" class="circle-settings-icon ml-5 f-left rounded-effect">
						<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M7 16c.55 0 1 .45 1 1 0 1.1-.9 2-2 2-.17 0-.33-.02-.5-.05.31-.55.5-1.21.5-1.95 0-.55.45-1 1-1M18.67 3c-.26 0-.51.1-.71.29L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41l-1.34-1.34c-.2-.2-.45-.29-.7-.29zM7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3z"/></svg>
					</a>
				</div>
			</div>
			<div class="col20 f-left flex justify-center mt-15 mb-25 flex-col">
				<h2 class="circle-name col20 f-left">Circle Name</h2>
				<span class="circle-members-info col20 f-left">729 Members</span>
			</div>
			<div class="inner-circles-wrapper-outer col20 f-left">

			</div>
		</div>
		<div class="circle-content">
			<div class="circle-content-controls">
				<div class="circle-top-controls circle-page-status-wrapper">
					<div class="flex align-center">
						<span class="mr-10">Status</span>
						<span class="circle-page-status rounded-effect">Completed</span>
					</div>
				</div>
			</div>
			<div class="sections-wrapper profile-inner-wrapper" style="margin-bottom: 60px;">
				<!-- Enroll Option -->
				<div class="circle-access-message">
					<div class="col20 f-left">
						<svg  class="circle-access-message-icon" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24"/></g><g><path d="M11,7L9.6,8.4l2.6,2.6H2v2h10.2l-2.6,2.6L11,17l5-5L11,7z M20,19h-8v2h8c1.1,0,2-0.9,2-2V5c0-1.1-0.9-2-2-2h-8v2h8V19z"/></g></svg>
					</div>
					<span class="circle-access-message-title col20 f-left">Do you want to join this course?</span>
					<span class="circle-access-message-description col20 f-left">Description of the course or some other message</span>
					<div class="col20 f-left t-center">
						<a href="" class="circle-access-message-button circle-effect">Join Now</a>
					</div>
				</div>
				<!-- Enroll Option END -->
				<!-- Login Required -->
				<div class="circle-access-message">
					<div class="col20 f-left">
						<svg class="circle-access-message-icon" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24"/></g><g><g><path d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M7.35,18.5C8.66,17.56,10.26,17,12,17 s3.34,0.56,4.65,1.5C15.34,19.44,13.74,20,12,20S8.66,19.44,7.35,18.5z M18.14,17.12L18.14,17.12C16.45,15.8,14.32,15,12,15 s-4.45,0.8-6.14,2.12l0,0C4.7,15.73,4,13.95,4,12c0-4.42,3.58-8,8-8s8,3.58,8,8C20,13.95,19.3,15.73,18.14,17.12z"/><path d="M12,6c-1.93,0-3.5,1.57-3.5,3.5S10.07,13,12,13s3.5-1.57,3.5-3.5S13.93,6,12,6z M12,11c-0.83,0-1.5-0.67-1.5-1.5 S11.17,8,12,8s1.5,0.67,1.5,1.5S12.83,11,12,11z"/></g></g></svg>
					</div>
					<span class="circle-access-message-title col20 f-left">Sign Up Required</span>
					<span class="circle-access-message-description col20 f-left">Description of the course or some other message</span>
					<div class="col20 f-left t-center">
						<a href="" class="circle-access-message-button circle-effect">Sign Up Now</a>
					</div>
				</div>
				<!-- Login Required END -->
				<!-- Paywall -->
				<div class="circle-access-message">
					<div class="col20 f-left">
						<svg class="circle-access-message-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z"/></svg>
					</div>
					<span class="circle-access-message-title col20 f-left">Paid Content</span>
					<span class="circle-access-price">$99.00 <span class="circle-access-price-monthly">/month</span></span>
					<span class="circle-access-message-description col20 f-left">Description of the course or some other message</span>
					<div class="col20 f-left t-center">
						<a href="" class="circle-access-message-button circle-effect">Get Access Now</a>
					</div>
				</div>
				<!-- Paywall END -->
				<!-- Circles List Widget + Inside a tab in the Member's Profile -->
				<div class="col20 f-left circle-list-wrapper mb-35" style="padding: 0 10%; box-sizing: border-box;">
					<div class="circle-list-item">
						<div class="circle-cover col20 f-left">	</div>
						<div class="col20 f-left circle-image-outer flex justify-center">
							<div style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)"  class="circle-image"></div>
						</div>
						<div class="col20 f-left flex justify-center mt-15 mb-15 flex-col">
							<h2 class="circle-name col20 f-left">Circle Name</h2>
							<span class="circle-members-info col20 f-left">729 Members</span>
						</div>
						<div class="col20 f-left t-center">
							<a href="" class="circle-access-btn circle-effect">Get Access Now</a>
						</div>
					</div>
					<div class="circle-list-item">
						<div class="circle-cover col20 f-left">	</div>
						<div class="col20 f-left circle-image-outer flex justify-center">
							<div style="background-image: url(https://content.app-sources.com/s/56276073477626212/uploads/Images/1-9342609.jpg)"  class="circle-image"></div>
						</div>
						<div class="col20 f-left flex justify-center mt-15 mb-15 flex-col">
							<h2 class="circle-name col20 f-left">Circle Name</h2>
							<span class="circle-members-info col20 f-left">729 Members</span>
							<span class="circle-access-price">$99.00 <span class="circle-access-price-monthly">/month</span></span>
							<span class="circle-description col20 f-left">An optional description about the circle will go in this area.</span>
						</div>
						<div class="col20 f-left t-center">
							<a href="" class="circle-access-btn circle-effect">Get Access Now</a>
						</div>
					</div>
				</div>
				<!-- Circles List Widget -->
			</div>
		</div>
	</div>

	<!-- End of style 2 -->

</div>

<div class="account-settings store-products" style="height: auto;">
	<div class="inner-wrapper members-table-wrapper">
		<div class="top-background-wrapper narrow-top-background dash-top-background" style="padding-top: 35px;">
			<div class="top-background">
				<div class="text-wrapper flex align-center flex-col-mobile align-left-mobile col20 f-left">
					<h1 class="members-title f-left t-center" style="margin-bottom: 0px;">Circle Analytics</h1>
					<div class="flex align-center">
						<div class="f-left">
							<div class="custom-dropdown">
								<div class="flex align-center custom-dropdown-button circle-effect"><span class="material-icons date-range-icon">date_range</span> Last 7 days <span class="material-icons">keyboard_arrow_down</span></div>
							</div>
						</div>
						<h4 class="ml-15 hide-mobile" style="color: rgb(255, 255, 255);">for</h4>
						<div class="custom-dropdown ml-15">
							<div class="flex align-center custom-dropdown-button circle-effect">All Circles <span class="material-icons">keyboard_arrow_down</span></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="content-wrapper">
			<div class="sections-wrapper profile-inner-wrapper bg-white box-shadow" style="margin-bottom: 60px;">
				<div class="upper-navigation upper-navigation-full mt-15">
					<ul>
						<li><a>Getting Started</a></li>
						<li><a class="active">Overview</a></li>
						<li><a>Content</a></li>
					</ul>
				</div>
				<div class="padding-45 f-left col20" style="padding-top: 25px;">
					<div class="flex col20 f-left store-section-analytics-warapper narrow-analytics-boxes flex-col-mobile" style="background: rgb(245, 246, 250) none repeat scroll 0% 0%; margin-top: 0px;">
						<div class="analytics-box analytics-box-small col5">
							<h3 class="flex align-center">New Members <span class="chart-color ml-10" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span></h3>
							<h2 class="col20 f-left f-28 gray-text"><b>0</b></h2>
						</div>
						<div class="analytics-box analytics-box-small col5">
							<h3 class="flex align-center">
								New Paying Members
								<span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">
                  info
                  <span class="none-soft hidden-info">
                    <h4>Cancelations (Churn)</h4>
                    <span>The total amount of subscriptions that were cancelled in the selected period.</span>
                  </span>
                </span>
								<span class="chart-color ml-10" style="background: rgb(255, 152, 0) none repeat scroll 0% 0%"></span>
							</h3>
							<h2 class="col20 f-left f-28 gray-text"><b>0 <span class="decrease none">5 (83.3%) lifetime</span></b></h2>
						</div>
						<div class="analytics-box analytics-box-small">
							<h3 class="flex align-center">
								Revenue
								<span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">
                  info
                  <span class="none-soft hidden-info">
                    <h4>Monthly Recurring Revenue</h4>
                    <span>New MRR shows how much new monthly recurring revenue was acquired in the selected period.</span>
                  </span>
                </span>
								<span class="chart-color ml-10" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>
							</h3>
							<h2 class="col20 f-left f-28 gray-text"><b>$0.00</b></h2>
						</div>
						<div class="analytics-box analytics-box-small col5">
							<h3 class="flex align-center">
								Completed Content
								<span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">
                  info
                  <span class="none-soft hidden-info">
                    <h4>Revenue</h4>
                    <span>The revenue that came from renewals and new subscriptions combined.</span>
                  </span>
                </span>
							</h3>
							<h2 class="col20 f-left f-28 gray-text"><b>265</b></h2>
						</div>
					</div>
					<div class="flex f-left col20 mt-25 flex-col-mobile">
						<div class="analytics-box-big three-fourth no-bpadding-mobile">
							<h2 class="col20 f-left f-28 gray-text">Members and Revenue</h2>
							<div class="col20 f-left relative mt-25 modern-chart-box">
								<canvas style="display: block; box-sizing: border-box; height: 330px; width: 660px;" width="660" height="330"></canvas>
								<div class="axis">
									<div class="tick"><span class="tick-label">27 May</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
									<div class="tick"><span class="tick-label">28 May</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
									<div class="tick"><span class="tick-label">29 May</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$20.00</span> </div>
									<div class="tick"><span class="tick-label">30 May</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
									<div class="tick"><span class="tick-label">31 May</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
									<div class="tick"><span class="tick-label">1 Jun</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
									<div class="tick"><span class="tick-label">2 Jun</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
								</div>
							</div>
						</div>
						<div class="one-fourth-analytics f-right">
							<div class="analytics-box">
								<div class="analytics-box analytics-box-small col20 analytics-box-small-clear">
									<h3>All Members</h3>
									<h2 class="col20 f-left f-28 gray-text"><b>682</b> <span class="col20 f-left mt-5" style="margin-left: 0px; opacity: 0.7;">6 Pending</span></h2>
								</div>
								<div class="analytics-box analytics-box-small col20 analytics-box-small-clear mt-35">
									<h3>All Paying Members</h3>
									<h2 class="col20 f-left f-28 gray-text"><b>323</b> <span class="col20 f-left mt-5" style="margin-left: 0px; opacity: 0.7;">47% Conversion Rate</span></h2>
								</div>
								<div class="analytics-box analytics-box-small col20 analytics-box-small-clear mt-35">
									<h3 class="flex align-center">
										Total MRR
										<span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">
                      info
                      <span class="none-soft hidden-info">
                        <h4>Average Revenue Per User</h4>
                        <span>ARPU shows you how much is your average monthly revenue per subscriber.</span>
                      </span>
                    </span>
									</h3>
									<h2 class="col20 f-left f-28 gray-text"><b>$8,452.00</b></h2>
								</div>
								<div class="analytics-box analytics-box-small col20 analytics-box-small-clear mt-35">
									<h3 class="flex align-center">
										ARPU
										<span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">
                      info
                      <span class="none-soft hidden-info">
                        <h4>Average Revenue Per User</h4>
                        <span>ARPU shows you how much is your average monthly revenue per subscriber.</span>
                      </span>
                    </span>
									</h3>
									<h2 class="col20 f-left f-28 gray-text"><b>$261.00</b></h2>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>


<div class="account-settings store-products" style="height: auto;">
	<div class="inner-wrapper members-table-wrapper">
		<div class="top-background-wrapper narrow-top-background dash-top-background" style="padding-top: 35px;">
			<div class="top-background">
				<div class="text-wrapper flex align-center flex-col-mobile align-left-mobile col20 f-left">
					<h1 class="members-title f-left t-center" style="margin-bottom: 0px;">Circle Analytics</h1>
					<div class="flex align-center">
						<div class="f-left">
							<div class="custom-dropdown">
								<div class="flex align-center custom-dropdown-button circle-effect"><span class="material-icons date-range-icon">date_range</span> Last 7 days <span class="material-icons">keyboard_arrow_down</span></div>
							</div>
						</div>
						<h4 class="ml-15 hide-mobile" style="color: rgb(255, 255, 255);">for</h4>
						<div class="custom-dropdown ml-15">
							<div class="flex align-center custom-dropdown-button circle-effect">All Circles <span class="material-icons">keyboard_arrow_down</span></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="content-wrapper">
			<div class="sections-wrapper profile-inner-wrapper bg-white box-shadow" style="margin-bottom: 60px;">
				<div class="upper-navigation upper-navigation-full mt-15">
					<ul>
						<li><a >Overview</a></li>
						<li><a class="active">Content</a></li>
					</ul>
				</div>
				<div class="padding-45 f-left col20" style="padding-top: 25px;">
					<div class="flex col20 f-left store-section-analytics-warapper narrow-analytics-boxes flex-col-mobile" style="background: rgb(245, 246, 250) none repeat scroll 0% 0%; margin-top: 0px;">
						<div class="analytics-box analytics-box-small col5">
							<h3 class="flex align-center">In Progress <span class="chart-color ml-10" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span></h3>
							<h2 class="col20 f-left f-28 gray-text"><b>0</b></h2>
						</div>
						<div class="analytics-box analytics-box-small col5">
							<h3 class="flex align-center">
								Completed
								<span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">
                  info
                  <span class="none-soft hidden-info">
                    <h4>Cancelations (Churn)</h4>
                    <span>The total amount of subscriptions that were cancelled in the selected period.</span>
                  </span>
                </span>
								<span class="chart-color ml-10" style="background: rgb(255, 152, 0) none repeat scroll 0% 0%"></span>
							</h3>
							<h2 class="col20 f-left f-28 gray-text"><b>0 <span class="decrease none">5 (83.3%) lifetime</span></b></h2>
						</div>
						<div class="analytics-box analytics-box-small col5">
							<h3 class="flex align-center">
								Inner Circles
							</h3>
							<h2 class="col20 f-left f-28 gray-text"><b>6</b></h2>
						</div>
						<div class="analytics-box analytics-box-small col5">
							<h3 class="flex align-center">
								Page Content
							</h3>
							<h2 class="col20 f-left f-28 gray-text"><b>62</b></h2>
						</div>
					</div>

					<div class="col20 f-left mt-25">
						<div class="upper-navigation upper-navigation-full inner-upper-nav mb-25">
							<ul>
								<li><a>Circles</a></li>
								<li><a>Inner Circles</a></li>
								<li><a class="active">Page Content</a></li>
							</ul>
						</div>
						<div class="scrollable-table orders-scrollable-table scrollable-table-design2">
							<table style="margin-top: 0px;">
								<thead>
								<tr class="flex flex-row align-center" style="padding-bottom: 0px;">
									<th class="flex-none mw-300" style="padding-left: 20px;"><a>Name</a></th>
									<th class="flex-none"><a>Enrolled</a></th>
									<th class="flex-none mw-120"><a>Status</a></th>
									<th class="flex-none"><a>In Progress</a></th>
									<th class="flex-none"><a>Completed</a></th>
									<th class="flex-none"><a>Revenue</a></th>
								</tr>
								</thead>
								<tbody style="height: auto;">
								<tr class="flex flex-row align-center" data-id="99">
									<td class="flex-none mw-300" style="padding-left: 20px;">Content Page Name</td>
									<td class="flex-none" style="font-size: 15px">723</td>
									<td class="flex-none mw-120"><span class="pay-status paid">Open</span>  </td>
									<td class="flex-none">425</td>
									<td class="flex-none">237</td>
									<td class="flex-none">$7,529</td>
								</tr>
								<tr class="flex flex-row align-center" data-id="99">
									<td class="flex-none mw-300" style="padding-left: 20px;">Content Page Name</td>
									<td class="flex-none" style="font-size: 15px">723</td>
									<td class="flex-none mw-120"><span class="pay-status not-paid">Scheduled</span>  </td>
									<td class="flex-none">425</td>
									<td class="flex-none">237</td>
									<td class="flex-none">$7,529</td>
								</tr>
								<tr class="flex flex-row align-center" data-id="99">
									<td class="flex-none mw-300" style="padding-left: 20px;">Content Page Name</td>
									<td class="flex-none" style="font-size: 15px">723</td>
									<td class="flex-none mw-120"><span class="pay-status shipped">Paywall</span>  </td>
									<td class="flex-none">425</td>
									<td class="flex-none">237</td>
									<td class="flex-none">$7,529</td>
								</tr>
								</tbody>
							</table>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
</div>




<div class="flex flex-col col20 f-left align-center">

	<div class="top-background-wrapper wide-top-background">
		<div class="top-background" style="max-width: 1350px;">
			<div class="text-wrapper">
				<div class="flex-centered f-left booking-buttons-wrapper">
					<div>
						<h1 class="members-title f-left mb-0">Circles</h1>
					</div>
					<a class="create-booking-btn middle-button blue with-icon f-left" style="margin-left: 25px;" rel="tab" href="/me/crm/booking/">
						Create New Circle
					</a>
				</div>
			</div>
		</div>
	</div>

	<!-- List of Circles Body -->

	<div class="content-wrapper horizontal-flex-table col20" style="max-width: 1350px; margin-top: 13px;" data-role="table-content">
		<div class="sections-wrapper members-wrapper horizontal-flex-table">
			<div class="section-bg members-wrapper products-wrapper crm-table-outer" style="box-shadow: none; padding: 0;">
				<div class="booked-events-wrapper">
					<div id="bookingEvents" class="table-header-wrapper">
						<table class="crm-table universal-table-wrapper" style="margin-top: 0; width: 100%; min-width: 100%;">
							<thead class="table-header">
							<tr style="border-bottom: 0;">
								<th>
									<div class="starting-cell"></div>
								</th>
								<th>
									<div class="small-cell">Circle Name</div>
								</th>
								<th>
									<div class="small-cell">Members</div>
								</th>
								<th >
									<div class="small-cell">Status</div>
								</th>
								<th style="width: 20%;">
									<div class="small-cell"></div>
								</th>
							</tr>
							</thead>
							<tbody class="tall-table booking-body">
							<tr data-id="67058">
								<td>
									<div class="starting-cell"><span class="material-icons blue-text booking-event-icon"> hdr_weak </span></div>
								</td>
								<td>
									<div class="small-cell fs-18 text-btn"><a rel="tab" data-tab="booking" href="/me/crm/booking/67058" class="blue-text">Circle Name Goes Here</a></div>
								</td>
								<td>
									<div class="small-cell">372</div>
								</td>
								<td>
									<div class="small-cell"><span class="pay-status paid">Public</span></div>
								</td>
								<td>
									<div class="small-cell"><a class="circle-settings" rel="action"><i class="material-icons-outlined">analytics</i></a></div>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="filter-nav members-subnav bookings-nav flex-none ta-left p-0-h-0" style="height: 100%;">
	<h3>Community</h3>
	<span style="color: #999; line-height: 1.4;">Create your circle groups, communities and manage all from one place.</span>
	<ul class="larger-nav f-left larger-nav-with-icons mt-35 mobile-hidden">
		<li class="operators">
			<a rel="tab" href="/me/crm/bookings/operators">
				<span><span class="material-icons-outlined"> dashboard </span>Dashboard</span>
				<span></span>
			</a>
		</li>
		<li class="bookings active">
			<a rel="tab" href="/me/crm/bookings">
				<span><span class="material-icons"> hdr_weak </span>Circles #</span>
				<span></span>
			</a>
		</li>
		<li class="schedule">
			<a rel="tab" href="/me/crm/bookings/schedule">
				<span><span class="material-icons-outlined" style="font-size:21px;margin-right:15px;"> account_circle </span>Members</span>
				<span></span>
			</a>
		</li>
		<li class="services">
			<a rel="tab" href="/me/crm/bookings/services">
				<span><span class="material-icons-outlined"> settings </span>Settings</span>
				<span></span>
			</a>
		</li>
	</ul>
</div>
